import styled from '@emotion/styled';
import { Subtitle } from '@silvertours/front-shared';
import ArrowDown from '@engineering/icons/arrow-down';
import type { HasColumns } from '../../../rule';
import { formatColumns } from '../../../particle';

/* @TODO: Add correct FLOYT colors to theme. */

const ArrowDownIcon = styled(ArrowDown)`
  width: 1.5rem;
  height: 1.5rem;

  ${({ theme }) => theme.mq('sm')} {
    width: 2rem;
    height: 2rem;
  }
`;

const AccordionItemTitle = styled(Subtitle)`
  margin: 0;
  grid-column: span 10;
  transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);
`;

const AccordionItemWrapper = styled.details<{ isFirst: boolean }>`
  border-top: ${({ theme, isFirst }) =>
    isFirst ? '' : `1px solid ${theme.colors.neutral.grey80}`};

  &[open] ${ArrowDownIcon} {
    transform: scaleY(-1);
  }
`;

const AccordionItemPromptWrapper = styled.summary`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral.grey20};

    ${AccordionItemTitle} {
      transform: translateX(0.5rem);
    }
  }

  &:focus-visible {
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }

  &::-webkit-details-marker {
    display: none;
  }

  ${({ theme }) => theme.mq('lg')} {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
`;

const AccordionItemContentWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(12, minmax(0, 1fr));
  gap: 1.5rem;
  margin-bottom: 1rem;

  ${({ theme }) => theme.mq('lg')} {
    margin-top: 1rem;
    margin-bottom: 1.5rem;
  }
`;

const AccordionItemArrow = styled.span`
  grid-column: span 2;
  display: flex;
  justify-content: end;
  fill: ${({ theme }) => theme.colors.neutral.grey160};
`;

const AccordionFigure = styled.figure<{ rules: HasColumns }>`
  ${({ theme, rules }) =>
    rules.columns?.map(columns => formatColumns(columns, theme))};

  filter: drop-shadow(0 10px 25px rgb(0 0 0 / 8%));

  img {
    border-radius: ${({ theme }) => theme.radius.md};
  }
`;

export {
  ArrowDownIcon,
  AccordionItemWrapper,
  AccordionItemPromptWrapper,
  AccordionItemContentWrapper,
  AccordionItemTitle,
  AccordionItemArrow,
  AccordionFigure,
};
